import { render, staticRenderFns } from "./EmptyModel.vue?vue&type=template&id=a5bdc932&"
import script from "./EmptyModel.vue?vue&type=script&lang=ts&"
export * from "./EmptyModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports